import type { ContactInfo } from '../types'

export const contactInfo: ContactInfo = {
  email: 'info@smartsupporttech.in',
  phone: '+917598131777',
  whatsapp: 'https://wa.me/917598131777',
  address: 'Thuckaly, Nagercoil',
  socials: {
    instagram: 'https://www.instagram.com/sst_webagency/',
    linkedin: 'https://www.linkedin.com/in/smart-support-158668417/',
    twitter: 'https://x.com/sst28042022',
    facebook: 'https://www.facebook.com/profile.php?id=61579175597618',
    youtube: 'https://www.youtube.com/@SSTWebAgency',
  },
}
